<template>
  <div class="post-job member-contact-download">
    <a v-on:click="popModal" tabindex="0" href="javascript: void(0);" id="membership-list_download-button" class="button light memberlist-button"><svg class="download-button_svg" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><title>123Asset 2cc</title><g id="Layer_2" data-name="Layer 2"><g id="ico-plus"><path id="icon" d="M13,6.5a.5.5,0,0,1-.5.5H7v5.5a.5.5,0,0,1-1,0V7H.5a.5.5,0,0,1,0-1H6V.5a.5.5,0,0,1,1,0V6h5.5A.5.5,0,0,1,13,6.5Z"/></g></g></svg>Download Contact List</a>
  </div>
</template>
<script>
import {toArray, simulateClick} from '../components/globals';

let showDownload = isLoggedIn
var
  memberDownloadButton = document.getElementById('membership-list_download-button'),
  memberDownloadWrap = document.getElementById('membership-list_modal-wrap'),
  memberDownloadExit = document.getElementById('membership-list_modal-close'),
  memberDownloadMask = document.getElementById('membership-list_modal-mask');

let previousActiveElement;
let modalFocusableNodes;
let modalFocusable;
var elFocusable = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[contenteditable]";

const KEYCODE = {
  ESC: 27,
  TAB: 9,
  SHIFT: 16,
  ENTER: 13
};

export default {
  data() {
    return {
      showDownload: isLoggedIn,
      button:null,
      wrap: memberDownloadWrap,
      mask: memberDownloadMask,
      exit: memberDownloadExit,
      elFocus: elFocusable
    }
  },
  methods: {
    hideDownload: function() {
      let downloadBtn = document.querySelector('.member-contact-download');
      if (this.showDownload === false){
        downloadBtn.style.display = 'none';
      } else {
        downloadBtn.style.display = "block"
      }
    },

    activateKeyCheck() {
      document.addEventListener('keydown', function(e) {
        if (e.which == KEYCODE.TAB) {
          var currentFocus = document.activeElement,
            modalFocusableNum = modalFocusable.length,
            focusedIndex = modalFocusable.indexOf(currentFocus);
          
          if (e.shiftKey) {
            if (focusedIndex === 0) {
                modalFocusable[(modalFocusableNum - 1)].focus();
                e.preventDefault();
            }
          } else {
            if (focusedIndex == modalFocusableNum - 1) {
                modalFocusable[0].focus();
                e.preventDefault();
            }
          }
        }
      })
    },
    createExitListener() {
      let self = this;

      if (memberDownloadMask) {
        memberDownloadMask.addEventListener('click', this.popModalExit);
      }

      memberDownloadExit.addEventListener('click', this.popModalExit);

      document.addEventListener('keydown', function(e) {
        if (e.which === KEYCODE.ESC) {
          self.popModalExit();
        }
      });
    },
    popModal(e) {
      e.preventDefault();

      previousActiveElement = document.activeElement;

      if (this.wrap) {
        modalFocusableNodes = this.wrap.querySelectorAll(elFocusable);
        modalFocusable = toArray(modalFocusableNodes);

        this.wrap.classList.add('active');
        this.mask.classList.add('active');
      }

      if (modalFocusable.length > 0) {
        modalFocusable[0].focus();
      }

      this.createExitListener();
      this.activateKeyCheck();
    },
    popModalExit() {
      this.mask.classList.remove('active');
      this.wrap.classList.remove('active');
      previousActiveElement.focus();
    }
  },
  mounted: function() {
    var memberDownloadButton = document.getElementById('membership-list_download-button');
    
    this.button = memberDownloadButton;
    this.hideDownload();

  },
  updated: function() {
    this.hideDownload()
  }
}
</script>



// WEBPACK FOOTER //
// CMS/NationalGuild/src/js/vueComponents/ContactListBtn.vue